// embed-instagram/client.js
// JS to initiate after DOMReady.
import _ from '../element/shared/utils/dont-need-lodash.js';
import socialEmbeds from '../element/shared/utils/social-embeds.js';

export default function () {
  // Add Instagram script
  const id = 'instagram-script';
  if (!document.getElementById(id)) {
    const script = document.createElement('script');
    script.id = id;
    script.async = true;
    script.defer = true;
    script.src = '//platform.instagram.com/en_US/embeds.js';
    document.body.appendChild(script);
  }

  // Load all Instagram embeds on the page
  const embeds = Array.prototype.slice.call(document.getElementsByClassName('js-embed-instagram'));
  embeds.forEach((element) => {
    if (!element.childNodes.length) {
      socialEmbeds.get(element);
    }
  });
}
